import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
  import { LotMapInterface } from "@/types/LotMapInterface";
  import { getLotStatus } from "@/helpers/customer";
  import {
    getLotCustomerMapStatusClass,
    getCustomerFacingLotStatusLabel,
  } from "@/helpers/status";
  import { LotStatus } from "@/enums/LotStatus";
  import { formatPrice } from "@/helpers/transformation/price";

  type propsType = {
    lot: LotMapInterface;
    hoverLotId: string;
    builderView: boolean;
  };

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotButtonLink',
  props: {
    lot: {},
    hoverLotId: {},
    builderView: { type: Boolean }
  },
  emits: ["onLotHover", "onLotBuilderHover", "onClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const hover = ref(false);
  const builderHover = ref(false);
  const builderIconRef = ref();

  const props = __props;

  const emits = __emit;

  const onHover = () => {
    hover.value = true;
    emits("onLotHover", true, props.lot.lotId._id);
  };

  const onMouseLeave = () => {
    hover.value = false;
    emits("onLotHover", false, props.lot.lotId._id);
  };

  const onBuilderHover = () => {
    builderHover.value = true;
    emits("onLotBuilderHover", true, props.lot.lotId._id);
  };

  const onBuilderLeave = () => {
    builderHover.value = false;
    emits("onLotBuilderHover", false, props.lot.lotId._id);
  };

  const onClick = () => {
    emits("onClick", props.lot);
  };

  watch(
    () => props.hoverLotId,
    () => {
      if (props.hoverLotId === props.lot.lotId._id) {
        hover.value = true;
      } else {
        hover.value = false;
      }
    }
  );

const __returned__ = { hover, builderHover, builderIconRef, props, emits, onHover, onMouseLeave, onBuilderHover, onBuilderLeave, onClick, ref, watch, get LotMapInterface() { return LotMapInterface }, get getLotStatus() { return getLotStatus }, get getLotCustomerMapStatusClass() { return getLotCustomerMapStatusClass }, get getCustomerFacingLotStatusLabel() { return getCustomerFacingLotStatusLabel }, get LotStatus() { return LotStatus }, get formatPrice() { return formatPrice } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})